<template>
    <div>
        <div style="text-align: center">
            <h3>{{ form.id ? 'Edit Node Server' : 'Tambah Node Server' }}</h3>
        </div>
        <br />
        <form v-on:submit.prevent="saveNodeServer">
            <label for="">Server URL*</label>
            <input type="text" class="form-control" v-model="form.server_url" placeholder="http://localhost:3000" required />
            <br>
            <label for="">Multidevice*</label>
            <select v-model="form.multidevice" class="form-control" required>
                <option :value="0">Single Device</option>
                <option :value="1">Multi Device</option>
            </select>
            <br>
            <label for="">Token*</label>
            <input type="text" class="form-control" v-model="form.token" placeholder="Token" required />
            <br>
            <label for="">Status*</label>
            <select v-model="form.active" class="form-control" required>
                <option :value="0">Tidak Aktif</option>
                <option :value="1">Aktif</option>
            </select>
            <br>
            <div class="button-group d-flex pt-25">
                <button type="submit"
                    class="btn btn-primary btn-block btn-default btn-squared text-capitalize mx-auto d-block">
                    simpan
                </button>
            </div>
        </form>
    </div>
</template>

<script>
    export default {
        props: {
            defaultValue: {
                type: Object,
                required: false,
            },
        },
        data() {
            return {
                form: {
                    id: null,
                    server_url: null,
                    multidevice: 0,
                    token: null,
                    active: 1,
                },
            };
        },
        watch: {
            defaultValue: {
                handler: function (val) {
                    if (val && val.id) {
                        this.form = {
                            id: val.id,
                            server_url: val.url || val.server_url,
                            multidevice: val.multidevice,
                            token: val.token,
                            active: val.active,
                        };
                    }
                },
                deep: true,
                immediate: true,
            },
        },
        methods: {
            async saveNodeServer() {
                try {
                    let req = {
                        server_url: this.form.server_url,
                        multidevice: parseInt(this.form.multidevice),
                        token: this.form.token,
                        active: parseInt(this.form.active),
                    };

                    if (this.form.id) {
                        // Update
                        req.id = this.form.id;
                        let response = await this.$store.dispatch('admin_node_server_update', req);
                        this.$toast.success(response.data.message);
                    } else {
                        // Create
                        let response = await this.$store.dispatch('admin_node_server_create', req);
                        this.$toast.success(response.data.message);
                    }
                    
                    this.$root.$emit("toggle_modal", "new_node_server");
                    this.$root.$emit("refresh_table", true);
                    
                    // Reset form
                    this.form = {
                        id: null,
                        server_url: null,
                        multidevice: 0,
                        token: null,
                        active: 1,
                    };
                } catch (err) {
                    this.$toast.error(err.response?.data?.message || "Failed to save node server");
                }
            }
        },
    };
</script>

<style scoped>

</style>



